import * as React from 'react'

export const SvgAccountFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 18 20" aria-hidden={true} {...props}>
    <path
      d="M9 10C11.7344 10 14 7.77344 14 5C14 2.26562 11.7344 0 9 0C6.22656 0 4 2.26562 4 5C4 7.77344 6.22656 10 9 10Z"
      fill="#383838"
    />
    <path
      d="M10.9531 11.875H7.00781C3.25781 11.875 0.25 14.9219 0.25 18.6719C0.25 19.4141 0.835938 20 1.57812 20H16.3828C17.125 20 17.75 19.4141 17.75 18.6719C17.75 14.9219 14.7031 11.875 10.9531 11.875Z"
      fill="#383838"
    />
  </svg>
)

export default SvgAccountFilledIcon
